import type { Listing } from '@thevillages/schemas';

import { Component, computed, inject } from '@angular/core';

import { InViewportDirective } from '../../directives/in-viewport';
import { FilteringService } from '../../services/filtering';
import { ListingsService } from '../../services/listings/listings';
import { SaveService } from '../../services/save/save';
import { StateService } from '../../services/state/state';
import { FiltersItem } from '../filters/item/item';
import { ListingCard } from '../listing-card/listing-card';
import { NoResults } from '../no-results/no-results';
import { Select } from '../select/select';
import { SuggestedModels } from '../suggested-models/suggested-models';

@Component({
  imports: [InViewportDirective, ListingCard, NoResults, Select, SuggestedModels, FiltersItem],
  selector: 'app-sidebar',
  styleUrl: './sidebar.css',
  templateUrl: './sidebar.html',
})
export class Sidebar {
  protected readonly filteringService = inject(FilteringService);
  protected readonly listingsService = inject(ListingsService);
  protected readonly saveService = inject(SaveService);
  protected readonly stateService = inject(StateService);

  protected readonly sortByOptions = [
    { label: 'Open Houses', value: 'open' },
    { label: 'Newest', value: 'newest' },
    { label: 'Price: Low to High', value: 'price-low' },
    { label: 'Price: High to Low', value: 'price-high' },
  ];
  protected readonly title = computed(() => {
    return this.filteringService.dreamHomes()
      ? `My Dream Homes for Sale in ${this.stateService.communityDisplayName()}`
      : `Homes for Sale in ${this.stateService.communityDisplayName()}`;
  });

  private _enteredListingId?: string;
  private _hoverEnterDebounceTimer?: ReturnType<typeof setTimeout>;
  private _hoverLeaveDebounceTimer?: ReturnType<typeof setTimeout>;

  protected loadMore(visible: boolean): void {
    if (!visible) {
      return;
    }
    if (this.filteringService.dreamHomes()) {
      return;
    }
    if (!this.stateService.initialListingsLoaded()) {
      return;
    }
    if (
      this.listingsService.sidebarListings().length === this.listingsService.allListings().length
    ) {
      return;
    }

    this.listingsService.chunk.update((c) => c + 20);
  }

  protected onEnter(listing: Listing): void {
    clearTimeout(this._hoverEnterDebounceTimer);
    this._hoverEnterDebounceTimer = undefined;

    this._hoverEnterDebounceTimer = setTimeout(() => {
      this._enteredListingId = listing.id;
      this.stateService.hoveredListing.set(listing);
    }, 300);
  }

  protected onLeave(): void {
    if (this._enteredListingId) {
      clearTimeout(this._hoverLeaveDebounceTimer);
      this._hoverLeaveDebounceTimer = undefined;

      this._hoverLeaveDebounceTimer = setTimeout(() => {
        this._enteredListingId = undefined;
        this.stateService.hoveredListing.set(undefined);
      }, 300);
    }
  }
}
